/**
 * STAGING-LAUNCH-READINESS-002-R1 — inline SVG flags (no CDN hotlink).
 */
import type { ReactElement, SVGProps } from "react";

type FlagProps = SVGProps<SVGSVGElement>;

function FlagJp(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#fff" />
      <circle cx="20" cy="15" r="7" fill="#bc002d" />
    </svg>
  );
}

function FlagKr(props: FlagProps) {
  // Taegeukgi (simplified 40×30): white field, red/blue taegeuk, four black trigrams.
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#fff" />
      {/* Upper-left ☰ geon (heaven): three solid bars */}
      <g fill="#000">
        <rect x="5.2" y="3.2" width="7.2" height="1.35" transform="rotate(-33 8.8 3.9)" />
        <rect x="5.2" y="5.35" width="7.2" height="1.35" transform="rotate(-33 8.8 6)" />
        <rect x="5.2" y="7.5" width="7.2" height="1.35" transform="rotate(-33 8.8 8.2)" />
      </g>
      {/* Lower-left ☲ ri (fire): solid / broken / solid */}
      <g fill="#000">
        <rect x="5.2" y="20.2" width="7.2" height="1.35" transform="rotate(33 8.8 20.9)" />
        <rect x="5.2" y="22.35" width="3" height="1.35" transform="rotate(33 6.7 23)" />
        <rect x="9.4" y="22.35" width="3" height="1.35" transform="rotate(33 10.9 23)" />
        <rect x="5.2" y="24.5" width="7.2" height="1.35" transform="rotate(33 8.8 25.2)" />
      </g>
      {/* Upper-right ☵ gam (water): broken / solid / broken */}
      <g fill="#000">
        <rect x="27.6" y="3.2" width="3" height="1.35" transform="rotate(33 29.1 3.9)" />
        <rect x="31.8" y="3.2" width="3" height="1.35" transform="rotate(33 33.3 3.9)" />
        <rect x="27.6" y="5.35" width="7.2" height="1.35" transform="rotate(33 31.2 6)" />
        <rect x="27.6" y="7.5" width="3" height="1.35" transform="rotate(33 29.1 8.2)" />
        <rect x="31.8" y="7.5" width="3" height="1.35" transform="rotate(33 33.3 8.2)" />
      </g>
      {/* Lower-right ☷ gon (earth): three broken bars */}
      <g fill="#000">
        <rect x="27.6" y="20.2" width="3" height="1.35" transform="rotate(-33 29.1 20.9)" />
        <rect x="31.8" y="20.2" width="3" height="1.35" transform="rotate(-33 33.3 20.9)" />
        <rect x="27.6" y="22.35" width="3" height="1.35" transform="rotate(-33 29.1 23)" />
        <rect x="31.8" y="22.35" width="3" height="1.35" transform="rotate(-33 33.3 23)" />
        <rect x="27.6" y="24.5" width="3" height="1.35" transform="rotate(-33 29.1 25.2)" />
        <rect x="31.8" y="24.5" width="3" height="1.35" transform="rotate(-33 33.3 25.2)" />
      </g>
      {/* Taegeuk: red (yang, upper) / blue (yin, lower) with interlocking S-curve */}
      <g transform="translate(20 15)">
        <circle r="6.2" fill="#cd2e3a" />
        <path d="M0-6.2A6.2 6.2 0 0 0 0 6.2A3.1 3.1 0 0 0 0 0A3.1 3.1 0 0 1 0-6.2Z" fill="#0047a0" />
        <circle cy="-3.1" r="3.1" fill="#cd2e3a" />
        <circle cy="3.1" r="3.1" fill="#0047a0" />
      </g>
    </svg>
  );
}

function FlagCn(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#de2910" />
      <polygon
        points="8,6 9.4,10.2 13.8,10.2 10.2,12.6 11.6,16.8 8,14.4 4.4,16.8 5.8,12.6 2.2,10.2 6.6,10.2"
        fill="#ffde00"
      />
      <circle cx="14" cy="5" r="1" fill="#ffde00" />
      <circle cx="16" cy="7" r="1" fill="#ffde00" />
      <circle cx="16" cy="10" r="1" fill="#ffde00" />
      <circle cx="14" cy="12" r="1" fill="#ffde00" />
    </svg>
  );
}

function FlagTh(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#fff" />
      <rect width="40" height="5" fill="#a51931" />
      <rect y="25" width="40" height="5" fill="#a51931" />
      <rect y="5" width="40" height="5" fill="#fff" />
      <rect y="20" width="40" height="5" fill="#fff" />
      <rect y="10" width="40" height="10" fill="#2d2a83" />
    </svg>
  );
}

function FlagVn(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#da251d" />
      <polygon points="20,7 22.5,14 30,14 23.8,18.2 26.2,25 20,20.8 13.8,25 16.2,18.2 10,14 17.5,14" fill="#ff0" />
    </svg>
  );
}

function FlagSg(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="15" fill="#ef3340" />
      <rect y="15" width="40" height="15" fill="#fff" />
      <circle cx="11" cy="10" r="4" fill="#fff" />
      <circle cx="12.5" cy="10" r="4" fill="#ef3340" />
      <circle cx="16" cy="6" r="1" fill="#fff" />
      <circle cx="18" cy="8" r="1" fill="#fff" />
      <circle cx="18" cy="11" r="1" fill="#fff" />
      <circle cx="16" cy="13" r="1" fill="#fff" />
      <circle cx="13" cy="13" r="1" fill="#fff" />
    </svg>
  );
}

function FlagTw(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#fe0000" />
      <rect width="20" height="15" fill="#000095" />
      <circle cx="10" cy="7.5" r="4" fill="#fff" />
      <circle cx="10" cy="7.5" r="3" fill="#000095" />
    </svg>
  );
}

function FlagMy(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#fff" />
      <rect width="40" height="6" fill="#cc0001" />
      <rect y="12" width="40" height="6" fill="#cc0001" />
      <rect y="24" width="40" height="6" fill="#cc0001" />
      <rect width="18" height="15" fill="#010066" />
      <circle cx="9" cy="7.5" r="3" fill="#ffcc00" />
      <polygon points="9,4.5 9.6,6.3 11.5,6.3 10,7.4 10.6,9.2 9,8.1 7.4,9.2 8,7.4 6.5,6.3 8.4,6.3" fill="#010066" />
    </svg>
  );
}

function FlagId(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="15" fill="#ce1126" />
      <rect y="15" width="40" height="15" fill="#fff" />
    </svg>
  );
}

function FlagHk(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="30" fill="#de2910" />
      <g fill="#fff">
        <path d="M20 8 L21.8 12.8 L20 12 Z" />
        <path d="M20 8 L18.2 12.8 L20 12 Z" transform="rotate(72 20 15)" />
        <path d="M20 8 L21.8 12.8 L20 12 Z" transform="rotate(144 20 15)" />
        <path d="M20 8 L18.2 12.8 L20 12 Z" transform="rotate(216 20 15)" />
        <path d="M20 8 L21.8 12.8 L20 12 Z" transform="rotate(288 20 15)" />
      </g>
      <circle cx="20" cy="15" r="6" fill="#fff" />
      <circle cx="20" cy="15" r="5.2" fill="#de2910" />
    </svg>
  );
}

function FlagIn(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="10" fill="#ff9933" />
      <rect y="10" width="40" height="10" fill="#fff" />
      <rect y="20" width="40" height="10" fill="#138808" />
      <circle cx="20" cy="15" r="3" fill="none" stroke="#000080" strokeWidth="0.5" />
      <circle cx="20" cy="15" r="0.6" fill="#000080" />
    </svg>
  );
}

function FlagPh(props: FlagProps) {
  return (
    <svg viewBox="0 0 40 30" aria-hidden="true" {...props}>
      <rect width="40" height="15" fill="#0038a8" />
      <rect y="15" width="40" height="15" fill="#ce1126" />
      <polygon points="0,0 14,15 0,30" fill="#fff" />
      <circle cx="4.5" cy="15" r="2.6" fill="#fcd116" />
      <circle cx="9" cy="6" r="1" fill="#fcd116" />
      <circle cx="9" cy="24" r="1" fill="#fcd116" />
      <circle cx="13" cy="15" r="1" fill="#fcd116" />
    </svg>
  );
}

const FLAG_BY_ISO2: Record<string, (props: FlagProps) => ReactElement> = {
  jp: FlagJp,
  kr: FlagKr,
  cn: FlagCn,
  th: FlagTh,
  vn: FlagVn,
  sg: FlagSg,
  tw: FlagTw,
  my: FlagMy,
  id: FlagId,
  hk: FlagHk,
  in: FlagIn,
  ph: FlagPh,
};

export function CountryFlagSvg({ iso2, className }: { iso2: string; className?: string }) {
  const code = String(iso2 ?? "")
    .trim()
    .toLowerCase();
  const Flag = FLAG_BY_ISO2[code];
  if (!Flag) return null;
  return <Flag className={className} />;
}
